'use strict';


module.exports = function fileInfoFromFileListContext(context) {
	if (!context || !context.activatedFiles || !context.activatedFilesContext || context.activatedFiles.length !== 1) {
		return false;
	}
	const currentFile = context.activatedFiles[0],
		fileId = currentFile.url.slice(4);

	if (context.activatedFilesContext.sharedFile) {
		return {
			fileId: fileId,
			allowedActions: {
				share: false
			}
		};
	}
	if (context.activatedFilesContext.myFile || context.activatedFilesContext.teamFile) {
		return {
			fileId: fileId,
			allowedActions: {
				share: true
			}
		};
	}
	return false;
};
